var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.userSettingOpened,
        callback: function($$v) {
          _vm.userSettingOpened = $$v
        },
        expression: "userSettingOpened"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { staticClass: "page-header", attrs: { dark: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onCloseClicked($event)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("fa-times")])],
                1
              ),
              _vm._v(" "),
              _c("v-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("message.userSettings")) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "pa-0 ma-0",
                      attrs: { dark: "", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.saveUserSettings($event)
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t\tSave\n\t\t\t\t")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-card-title", { staticClass: "pb-0 pl-6" }, [
                    _c("div", { staticClass: "headline" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("message.notificationSettings1")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", "pl-12": "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c("div", { staticClass: "subheader my-1" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("message.notificationSettings2")) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "font-xs mb-0" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("message.notificationSettings12")) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              [
                                _c(
                                  "v-container",
                                  { attrs: { fluid: "", "grid-list-sm": "" } },
                                  [
                                    _c("v-data-iterator", {
                                      attrs: {
                                        items: _vm.notificationTypes,
                                        "item-key": "code",
                                        row: "",
                                        wrap: "",
                                        "hide-default-footer": true
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "v-row",
                                                _vm._l(
                                                  props.items.filter(function(
                                                    i
                                                  ) {
                                                    return !_vm.isHiddenNotification(
                                                      i.code
                                                    )
                                                  }),
                                                  function(item) {
                                                    return _c(
                                                      "v-col",
                                                      {
                                                        key: item.code,
                                                        attrs: {
                                                          cols: "12",
                                                          sm: "6",
                                                          md: "4",
                                                          lg: "4"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-card",
                                                          [
                                                            _c("v-card-title", [
                                                              _c("h5", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.description
                                                                  )
                                                                )
                                                              ])
                                                            ]),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.notificationDeliveryTypes,
                                                              function(v, k) {
                                                                return _c(
                                                                  "v-switch",
                                                                  {
                                                                    key:
                                                                      "notificationDeliveryType-" +
                                                                      k,
                                                                    staticClass:
                                                                      "pl-3 mt-0",
                                                                    attrs: {
                                                                      label:
                                                                        v.description,
                                                                      value:
                                                                        item.id +
                                                                        "_" +
                                                                        v.id
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.notifications,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.notifications = $$v
                                                                      },
                                                                      expression:
                                                                        "notifications"
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    })
                                  ],
                                  1
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCancellationFeature ? _c("v-divider") : _vm._e(),
          _vm._v(" "),
          _vm.showCancellationFeature
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-card-title", { staticClass: "pb-0 pl-6" }, [
                        _c("div", { staticClass: "headline" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "profile.UserSettings_cancelAccountTitle"
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "pl-12": "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("p", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "profile.UserSettings_cancelAccountDescription1"
                                  )
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "profile.UserSettings_cancelAccountDescription2"
                                  )
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                value: _vm.deleteAccountManagerOfTeam,
                                type: "error"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "profile.UserSettings_cancelAccountAdminRoleWarning"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "error" },
                                  on: {
                                    click: function($event) {
                                      _vm.showBeforeYouGo = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "profile.UserSettings_cancelAccountButton"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showBeforeYouGo
                            ? _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("h4", [
                                    _c("strong", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "profile.UserSettings_cancelAccountPromptTitle"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "profile.UserSettings_cancelAccountPromptDescription1"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "profile.UserSettings_cancelAccountPromptDescription2"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-settings__delete-reason-list"
                                    },
                                    _vm._l(_vm.deletionReasons, function(
                                      reason,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: reason,
                                          staticClass:
                                            "user-settings__delete-reason-row"
                                        },
                                        [
                                          _c("TeamingCheckbox", {
                                            attrs: {
                                              name: "deletionReason",
                                              value: "" + index,
                                              "is-checked": _vm.isCancelReasonChecked(
                                                index
                                              )
                                            },
                                            on: {
                                              change: _vm.onCancelReasonChange
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", [_vm._v(_vm._s(reason))])
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        value: _vm.canSubmitCancellation,
                                        type: "error"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "profile.UserSettings_cancelAccountPromptValidationError"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "profile.UserSettings_cancelAccountPromptDescription3"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { outlined: "" },
                                    model: {
                                      value: _vm.deletionComment,
                                      callback: function($$v) {
                                        _vm.deletionComment = $$v
                                      },
                                      expression: "deletionComment"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        value: _vm.deleteAccountManagerOfTeam,
                                        type: "error"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "profile.UserSettings_cancelAccountPromptManagerError"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "info" },
                                              on: {
                                                click: _vm.abortCancelAccount
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.UserSettings_cancelAccountPromptCancelButton"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "error" },
                                              on: { click: _vm.cancelAccount }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "profile.UserSettings_cancelAccountPromptConfirmButton"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-card-title", { staticClass: "pb-0 pl-6" }, [
                        _c("div", { staticClass: "headline" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "profile.UserSettings_cancelAccountTitle"
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "pl-12": "" } },
                    [
                      _c("v-card-text", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "profile.UserSettings_cancelAccountPendingCancellationMessage"
                            )
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49696e3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49696e3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSettings.vue
// module id = 9KcX
// module chunks = 5